import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUnreadCount } from '../app/slices/notificationsSlice';

import AppLayout          from '../components/layout/AppLayout';
import LoginPage          from '../pages/auth/LoginPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import DashboardPage      from '../pages/dashboard/DashboardPage';
import TasksPage          from '../pages/tasks/TasksPage';
import UsersPage          from '../pages/users/UsersPage';
import DepartmentsPage    from '../pages/departments/DepartmentsPage';
import ApprovalsPage      from '../pages/approvals/ApprovalsPage';
import NotificationsPage  from '../pages/notifications/NotificationsPage';
import ProfilePage        from '../pages/profile/ProfilePage';

function RequireAuth({ children }) {
  const { token } = useSelector(s => s.auth);
  return token ? children : <Navigate to="/login" replace />;
}
function RequireAdmin({ children }) {
  const { user } = useSelector(s => s.auth);
  return user?.role === 'Admin' ? children : <Navigate to="/dashboard" replace />;
}
function GuestOnly({ children }) {
  const { token } = useSelector(s => s.auth);
  return token ? <Navigate to="/dashboard" replace /> : children;
}

function NotificationPoller() {
  const dispatch = useDispatch();
  const { token } = useSelector(s => s.auth);
  const timer = useRef(null);
  useEffect(() => {
    if (!token) return;
    dispatch(fetchUnreadCount());
    timer.current = setInterval(() => { if (!document.hidden) dispatch(fetchUnreadCount()); }, 30000);
    return () => clearInterval(timer.current);
  }, [token, dispatch]);
  return null;
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <NotificationPoller />
      <Routes>
        <Route path="/login"           element={<GuestOnly><LoginPage /></GuestOnly>} />
        <Route path="/forgot-password" element={<GuestOnly><ForgotPasswordPage /></GuestOnly>} />
        <Route path="/" element={<RequireAuth><AppLayout /></RequireAuth>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard"     element={<DashboardPage />} />
          <Route path="tasks"         element={<RequireAdmin><TasksPage /></RequireAdmin>} />
          <Route path="my-tasks"      element={<TasksPage myTasks />} />
          <Route path="users"         element={<RequireAdmin><UsersPage /></RequireAdmin>} />
          <Route path="departments"   element={<RequireAdmin><DepartmentsPage /></RequireAdmin>} />
          <Route path="approvals"     element={<RequireAdmin><ApprovalsPage /></RequireAdmin>} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="profile"       element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
